import { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { getBynderAccessToken } from 'packages/store/platform/platform.selectors';
import authService from '~/services/authService';

const useDirectAccessToken = () => {
    const bynderAccessToken = useSelector(getBynderAccessToken);
    const [token, setToken] = useState<string>('');

    const getDirectAccessToken = useCallback(() => {
        if (!bynderAccessToken) {
            return Promise.resolve('');
        }

        return authService.getDirectToken(bynderAccessToken);
    }, [bynderAccessToken]);

    useEffect(() => {
        const updateToken = () =>
            getDirectAccessToken()
                .then(setToken)
                .catch((error) => {
                    console.error('Error fetching direct access token:', error);
                    setToken('');
                });

        updateToken();
        // every 5 minutes
        const interval = setInterval(updateToken, 1000 * 60 * 5);

        return () => clearInterval(interval);
    }, [getDirectAccessToken]);

    return token;
};

export default useDirectAccessToken;
